import { fetchAssessment } from '@actions/assessments';
import {
    getAssessment,
    getAssessmentsFetchError,
    getAssessmentsIsFeching,
} from '@selectors/assessments';
import { RootState } from 'src/redux/reducers';

import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const useFetchAssessment = (submissionID: number) => {
    const dispatch = useDispatch();

    useEffect(() => {
        if (submissionID != null) dispatch(fetchAssessment(submissionID));
    }, [dispatch, submissionID]);

    const assessment = useSelector((state: RootState) => getAssessment(state, submissionID));
    const isFetching = useSelector(getAssessmentsIsFeching);
    const fetchError = useSelector(getAssessmentsFetchError);

    return { assessment, isFetching, fetchError };
};

export default useFetchAssessment;
